<p>edit-auto-closure works!</p>
